import React from "react";
import CText from "./CText";
import { View, TouchableOpacity } from "react-native";
import CImage from "./CImage";
import { useDeviceSize } from "rn-responsive-styles";
import CView from "./CView";

const CHeader = (props) => {
  const deviceSize = useDeviceSize()
  const isSmallScreen = deviceSize === "small" || deviceSize === "extrasmall"
  return (
    <View>
      {props.disputeHeader ? (
        <View style={{ ...styles.menuBar, ...props.style }}>
          <View style={styles.disputeHeaderWrapper}>
            {props.showBack && (
              <View style={{ flexDirection: "row" }}>
                <TouchableOpacity
                  onPress={() => props.onPress(props.navigation)}
                >
                  <CImage.backIcon />
                </TouchableOpacity>
                <CText.tripBenifitText style={{ marginLeft: 10 }}>
                  Back
                </CText.tripBenifitText>
              </View>
            )}

            <View style={styles.titleWrapper}>
              <CText.basicInformationSubHeader style={{ fontSize: 18 }}>
                {props.title}
              </CText.basicInformationSubHeader>
            </View>
            <View>
              {props.refresh11 && (
                <TouchableOpacity
                  style={[
                    styles.titleWrapper,
                    { flexDirection: "row", marginLeft: 10, paddingTop: 2 },
                  ]}
                  onPress={() => props.onRefreshPress()}
                >
                  <CImage.RefreshImage />

                  <CText.inputTopLabel style={{ paddingLeft: 10 }}>
                    {"Refresh"}
                  </CText.inputTopLabel>
                </TouchableOpacity>
              )}
            </View>
            <View>
              {props?.qrCode && (
                <TouchableOpacity
                  style={
                    styles.qrWrapper}
                  onPress={() => props.qrcodeClcik()}
                >
                  {!isSmallScreen?<CImage.qrcodeIcon />:null}
                  <View style={[
                    styles.qrWrapper,
                    { flexDirection: "column",alignItems:'flex-start'},
                  ]}>
                    <CText.cancelPolicyConfirmText>
                      {"Recharge via QR Code"}
                    </CText.cancelPolicyConfirmText>
                    <CText.srDate>
                      {"Download your code"}
                    </CText.srDate>
                  </View>
                  <CView style={{marginLeft:"10px"}}> <CImage.downloadIcon /></CView>
                 

                  
                </TouchableOpacity>
              )}
            </View>
          </View>
        </View>
      ) : (
        <View style={{ ...styles.menuBar, ...props.style }}>
          <View style={styles.headerWrapper}>
            <TouchableOpacity onPress={() => props.onPress(props.navigation)}>
              <CImage.backIcon />
            </TouchableOpacity>
            <View style={styles.titleWrapper}>
              <CText.backNavigationText>{props.title}</CText.backNavigationText>
            </View>
          </View>
        </View>
      )}
    </View>
  );
};
const styles = {
  menuBar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 30,
    marginTop: 10,
    zIndex: 5,
    paddingTop: 10,

    width: "100%",
    height: 70,
    borderRadius: 12,
    backgroundColor: "#ffffff",
    shadowColor: "rgba(0, 0, 0, 0.06)",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
  },
  headerWrapper: {
    alignItems: "center",
    flexDirection: "row",
  },
  disputeHeaderWrapper: {
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
  titleWrapper: {
    alignItems: "center",
    paddingLeft: 20,
  },
  qrWrapper: {
    alignItems: "center",
    flexDirection: "row",
    paddingTop: 2,
    marginHorizontal:4
  },
};


export default CHeader;
